if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const elements = document.querySelectorAll('.scroll-open');

  let lastScrollY = window.scrollY;
  let scrollDirection = 'down';

  window.addEventListener(
    'scroll',
    () => {
      const currentScrollY = window.scrollY;
      scrollDirection = currentScrollY < lastScrollY ? 'up' : 'down';
      lastScrollY = currentScrollY;
    },
    { passive: true }
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const element = entry.target;
        element.classList.toggle('dir-up', scrollDirection === 'up');
        element.classList.toggle('is-open', entry.isIntersecting);
      });
    },
    { threshold: 0.15 }
  );

  elements.forEach((element) => observer.observe(element));
}
